import { createFileRoute } from '@tanstack/react-router';
import { SetupResume } from '@/pages/workspaces/broadcasts/newsletter/setup/setup-resume';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/',
)({
  component: SetupResume,
});
